import { Message } from '@langchain/langgraph-sdk'
import { FormEvent, useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { ensureToolCallsHaveResponses } from '../../../lib/ensure-tool-responses'

interface UseThreadFormProps {
    input: string
    isLoading: boolean
    clearInput: () => void
    setFirstToken: (received: boolean) => void
    stream: any
}

export function useThreadForm({ input, isLoading, clearInput, setFirstToken, stream }: UseThreadFormProps) {
    const handleSubmit = useCallback(
        (e: FormEvent) => {
            e.preventDefault()
            if (!input.trim() || isLoading) return

            setFirstToken(false)

            const newHumanMessage: Message = {
                id: uuidv4(),
                type: 'human',
                content: input
            }

            const toolMessages = ensureToolCallsHaveResponses(stream.messages)
            stream.submit(
                { messages: [...toolMessages, newHumanMessage] },
                {
                    streamMode: ['values'],
                    optimisticValues: (prev) => ({
                        ...prev,
                        messages: [...(prev.messages ?? []), ...toolMessages, newHumanMessage]
                    })
                }
            )

            clearInput()
        },
        [input, isLoading, setFirstToken, stream, clearInput]
    )

    return {
        handleSubmit
    }
}
